import { useState } from 'react';
import axios from '../helpers/axios';
import * as Sentry from '@sentry/browser';
import { TeamInfoPayload, UseSaveTeamInfoResult } from './hookTypes';
import { TeamResponse } from '@dto/api';

const useSaveTeamInfo = (): UseSaveTeamInfoResult => {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const saveTeamInfo = async (payload: TeamInfoPayload): Promise<TeamResponse> => {
        setSaving(true);
        setError(null);
        try {
            const response = await axios.post('/v2/teams', payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data as TeamResponse;
        } catch (err) {
            Sentry.captureException(err);
            setError('Failed to save team information. Please try again.');
            throw err;
        } finally {
            setSaving(false);
        }
    };

    return { saving, error, saveTeamInfo };
};

export default useSaveTeamInfo;
